import {scrollImageSection} from "../components/scroll-image-section";

export function initGradLanding() {
    if (!$('#grad_landing').length) return;
    scrollImageSection();
}

